import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import moment from "moment";
import PropTypes from "prop-types";
import { uniqBy } from "lodash";
import {
    fetchProvinces
} from "api/menu/master-files/locations/actions";
import {
    // eslint-disable-next-line import/named
    requestExportTravelLocationsReportExcel,
} from "../../../../actions/draftActions";
import SearchSelect from "../../../common/SearchSelect";
import MiscChargeReportList from "../misc-charges/misc-charge-report-list";
import { closeCustomModal } from "../../../custom/modals";
import { bindActionCreators } from "redux";

const TravelLocationsReportModal = ({
                                        fetchProvinces,
                                        provinces,
                                        handleClose,
                                        requestExportTravelLocationsReportExcel
                                    }) => {
    const [filters, setFilters] = useState({
        fromDate: moment().startOf("month"),
        toDate: moment().endOf("month"),
        provinces: []
    });

    const [provinceOptions, setProvinceOptions] = useState([]);  // Province options for the select
    const [allSelected, setAllSelected] = useState(false);  // Track if "Select All" is chosen

    useEffect(() => {
        fetchProvinces(1);
    }, [fetchProvinces]);

    useEffect(() => {
        if (provinces && provinces.length) {
            const options = provinces.map(item => ({
                value: item.id,
                label: item.fullName
            }));
            setProvinceOptions([{ value: "all", label: "Select All" }, ...uniqBy(options, "value")]);
        }
    }, [provinces]);

    const handleSelect = (selectedOptions) => {
        if (!selectedOptions) {
            setFilters({ ...filters, provinces: [] });
            setAllSelected(false);
            return;
        }

        // Check if "Select All" is selected
        const isAllSelected = selectedOptions.some(option => option.value === "all");

        if (isAllSelected) {
            // If "Select All" is selected, select all provinces
            if (!allSelected) {
                setFilters({
                    ...filters,
                    provinces: provinceOptions.slice(1) // Exclude "Select All"
                });
                setAllSelected(true);
            } else {
                // If "Select All" is unselected, clear all provinces
                setFilters({
                    ...filters,
                    provinces: []
                });
                setAllSelected(false);
            }
        } else {
            setFilters({
                ...filters,
                provinces: uniqBy(selectedOptions, "value")  // Ensure unique selections
            });
            setAllSelected(false);
        }
    };


    const handleSubmit = () => {
        const provinceIds = filters.provinces.map(province => province.value);  // Extract only the province IDs
        const exportFilters = {
            ...filters,
            provinceIds
        };

        requestExportTravelLocationsReportExcel(exportFilters);

        handleClose();
    };

    return (
        <div className="position-relative container">
            <SearchSelect
                className="custom-react-select"
                isMulti
                isClearable={false}
                options={provinceOptions}
                value={filters.provinces}
                onChange={handleSelect}
            />
            <MiscChargeReportList
                filters={filters}
                handleClose={handleClose}
                handleSubmit={handleSubmit}
            />
        </div>
    );
};

TravelLocationsReportModal.propTypes = {
    handleClose: PropTypes.func.isRequired,
    closeCustomModal: PropTypes.func.isRequired,
    fetchProvinces: PropTypes.func.isRequired,
    requestExportTravelLocationsReportExcel: PropTypes.func.isRequired,
    provinces: PropTypes.array.isRequired
};

// Mapping state from the Redux store to props
const mapStateToProps = state => ({
    provinces: state.locations.provinces
});

// Custom mapStateToDispatch function for dispatching actions
const mapStateToDispatch = dispatch => ({
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),
    fetchProvinces: (countryId) => dispatch(fetchProvinces(countryId)),
    requestExportTravelLocationsReportExcel: (filters) => dispatch(requestExportTravelLocationsReportExcel(filters)),
});

// Connect the component to Redux
export default connect(
    mapStateToProps,
    mapStateToDispatch
)(TravelLocationsReportModal);
